import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ComboService } from '../../Model/Combo/combo.service';
import { SessionService } from '../../Util/Session/session.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { LeftJoingDatePopupComponent } from '../../Component/left-joing-date-popup/left-joing-date-popup.component';

@Component({
  selector: 'app-muster-attendance-summary',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule, NgbTooltip, NgbTooltip],
  providers: [DatePipe],
  templateUrl: './muster-attendance-summary.component.html',
  styleUrl: './muster-attendance-summary.component.scss'
})
export class MusterAttendanceSummaryComponent {
  @Input() leftColumns: number = 3;
  @Input() centerColumns: number = 6;
  @Input() rightColumns: number = 3;
  @Input() tableData: any[] = [];
  @Input() dateKeys: any[] = [];
  @Input() siteID: number = 0;
  @Input() updatedDatas: any[] = [];
  @Input() IsLocked: boolean = false;
  @Input() CompanyPermiter = {
    IsAttendanceBeforeDaysAllowed: false,
    AttendanceBeforeDays: 0,
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
    IsUpdateDesignationDutyAllowed: false,
    IsAttendanceResetAllowed: false,
    IsAttendanceDeleteAllowed: false,
    IsAttendanceForSameDayAllowed: false,
    TodayDate: null,
  } as any;
  @Input() ErrorHighlight = [];
  @Input() FromDate = null;
  @Input() ToDate = null;
  @Output() empwiseClick = new EventEmitter<number>();
  @Output() datewiseClick = new EventEmitter<number>();
  @Output() daychange = new EventEmitter<any>();
  @Output() deleteEmpClick = new EventEmitter<any>();
  @Input() DesignationSummaryData: any[] = [];

  @ViewChildren('centerScroll') centerSections!: QueryList<ElementRef>;
  daysInMonth = 30;
  new: any;
  AttendanceTypes = [] as any;
  user = [] as any;
  private keyBuffer: string = '';
  private bufferTimeout: any = null;
  //Designations = [] as any;

  hasVerticalScroll = false;
  @ViewChild('myDiv') myDiv!: ElementRef<HTMLDivElement>;

  Totol = {
    P: 0,
    A: 0,
    CO: 0,
    WO: 0,
    H: 0,
    CL: 0,
    SL: 0,
    PL: 0,
    CD: 0,
    WD: 0,
    OT: 0,
    RT: 0,
  }

  constructor(
    protected common: CommonService,
    private combo: ComboService,
    private session: SessionService,
    protected datePipe: DatePipe,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private musterAttendance: MusterAttendanceService
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void { }

  ngAfterViewChecked(): void {
    const el = this.myDiv.nativeElement;
    this.hasVerticalScroll = el.scrollHeight > el.clientHeight;
  }

  // Update layout based on input changes
  updateLayout() {
    // This will automatically update the template through property binding
  }

  OnLoad() {
    this.ComboLoad('Attendance Type');
    this.Totol.P = this.tableData.map(e => e.P).reduce((total, current) => total + current, 0);
    this.Totol.A = this.tableData.map(e => e.A).reduce((total, current) => total + current, 0);
    this.Totol.CO = this.tableData.map(e => e.CO).reduce((total, current) => total + current, 0);
    this.Totol.WO = this.tableData.map(e => e.WO).reduce((total, current) => total + current, 0);
    this.Totol.H = this.tableData.map(e => e.H).reduce((total, current) => total + current, 0);
    this.Totol.CL = this.tableData.map(e => e.CL).reduce((total, current) => total + current, 0);
    this.Totol.SL = this.tableData.map(e => e.SL).reduce((total, current) => total + current, 0);
    this.Totol.PL = this.tableData.map(e => e.PL).reduce((total, current) => total + current, 0);
    this.Totol.CD = this.tableData.map(e => e['CALC DAYS']).reduce((total, current) => total + current, 0);
    this.Totol.WD = this.tableData.map(e => e['WORK DAYS']).reduce((total, current) => total + current, 0);
    this.Totol.OT = this.tableData.map(e => e.OT).reduce((total, current) => total + current, 0);
    this.Totol.RT = this.tableData.map(e => e.RT).reduce((total, current) => total + current, 0);

    // this.ComboLoad('Designation');
    // for (let i = 0; i < this.tableData.length; i++) {
    //   this.tableData[i].CDesignationMasterId = this.tableData[i].DesignationMasterId;
    //   this.tableData[i].CDutyMasterId = this.tableData[i].DutyMasterId;
    //   this.tableData[i].CShiftMasterId = this.tableData[i].ShiftMasterId;

    //   this.ComboLoad('Duty', i, this.tableData[i].DesignationMasterId, 0);
    //   //this.ComboLoad('ShiftLoadBasedOnDesignationDuty', i, this.tableData[i].DesignationMasterId, this.tableData[i].DutyMasterId);
    // }
  }

  onScroll(event: any) {
    this.centerSections.forEach(section => {
      if (section.nativeElement !== event.target) {
        section.nativeElement.scrollLeft = event.target.scrollLeft;
      }
    });
  }

  leftrightClick(IsLeft: boolean) {
    this.centerSections.forEach(section => {
      if (IsLeft) {
        section.nativeElement.scrollLeft -= 100;
      } else {
        section.nativeElement.scrollLeft += 100;
      }
    });
  }

  ComboLoad(Combotype: String, Index = 0, DesignationId = 0, DutyId = 0, isClear = false) {
    if (isClear) {
      if (Combotype == 'Duty') {
        this.tableData[Index].CDutyMasterId = null;
        this.tableData[Index].CShiftMasterId = null;

        this.tableData[Index].Dutys = [];
        this.tableData[Index].Shifts = [];
      }
      else if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
        this.tableData[Index].CShiftMasterId = null;
        this.tableData[Index].Shifts = [];
      }
    }

    this.combo.ComboLoad({
      'Combotype': Combotype, 'EmpMasterID': this.user.UserId,
      SiteId: this.siteID,
      DesignationId: DesignationId,
      DutyId: DutyId
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Attendance Type') {
          this.AttendanceTypes = response.ComboLoad;
        }
        // else if (Combotype == 'Designation') {
        //   this.Designations = response.ComboLoad;
        // } else if (Combotype == 'Duty') {
        //   this.tableData[Index].Dutys = response.ComboLoad;
        //   if (this.tableData[Index].Dutys.findIndex((e: any) => e.DutyMasterID == this.tableData[Index].CDutyMasterId) < 0) {
        //     this.tableData[Index].CDutyMasterId = null;
        //   }
        // }
        else if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
          this.tableData[Index].Shifts = response.ComboLoad;

          this.updatedDatas.filter((e: any) => e.EmpMasterId == this.tableData[Index].EmpMasterId && e.DesignationMasterId == this.tableData[Index].DesignationMasterId && e.DutyMasterId == this.tableData[Index].DutyMasterId).forEach(element => {
            if (this.tableData[Index].Shifts.findIndex((e: any) => e.ShiftMasterID == element.ShiftMasterId) < 0) {
              element.ShiftMasterId = this.tableData[Index].Shifts[0].ShiftMasterID;
            }
          });
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  GetDays(day: string) {
    return new Date(day).getDate();
  }

  Empwise(index: number) {
    this.empwiseClick.emit(index);
  }

  Datewise(index: number) {
    this.datewiseClick.emit(index);
  }

  onDayKeyPress(event: KeyboardEvent, employee: any, day: string) {
    event.stopPropagation();
    const currentElement = event.target as HTMLElement;

    if (event.key == 'Tab') {
      event.preventDefault(); // prevent default browser tabbing

      const allCells = Array.from(document.querySelectorAll('.day-data-cell')) as HTMLElement[];

      const currentIndex = allCells.indexOf(currentElement);
      const nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

      if (allCells[nextIndex]) {
        allCells[nextIndex].focus();
      }
    } else {
      const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, day);

      if ((difDay == 0
        || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay))
        || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay))
        && !this.IsLocked && this.common.PageRight.IsEdit
      ) {
        if (employee['IsAttendanceAllowed_' + day.replace(/\s+/g, '')] && this.CheckJoinLeftDate(day, employee.JoiningDate, employee.LeftDate)) {
          const key = event.key.toUpperCase();  // normalize to uppercase
          if (this.AttendanceTypes.map((e: any) => e.AttendanceTypeCode.toUpperCase()).some((code: any) => code.includes(key))) {
            if (this.bufferTimeout) {
              clearTimeout(this.bufferTimeout);
            }
            this.keyBuffer += event.key.toUpperCase();

            const matchedCode = this.AttendanceTypes
              .map((e: any) => e.AttendanceTypeCode)
              .find((code: string) => code === this.keyBuffer);

            if (matchedCode) {
              employee[day] = matchedCode;
              //console.log('1');
              this.emitDayChange(day, employee, matchedCode);
              this.clearBuffer();
            } else if (this.keyBuffer.length >= 2) {
              const firstChar = this.keyBuffer.charAt(0);
              if (this.AttendanceTypes.map((e: any) => e.AttendanceTypeCode).includes(firstChar)) {
                employee[day] = firstChar;
                //console.log('2');
                this.emitDayChange(day, employee, firstChar);
              }
              this.clearBuffer();
            }

            this.bufferTimeout = setTimeout(() => {
              if (this.keyBuffer.length === 1) {
                // Single character after timeout
                const singleChar = this.keyBuffer;
                if (this.AttendanceTypes.map((e: any) => e.AttendanceTypeCode).includes(singleChar)) {
                  employee[day] = singleChar;
                  //console.log('3');
                  this.emitDayChange(day, employee, singleChar);
                }
              }
              this.clearBuffer();
            }, 1000); // 1 second timeout
          } else if (key == 'BACKSPACE' || key == 'DELETE') {
            employee[day] = '';
            this.emitDayChange(day, employee, '');
          }
        }
      }
    }
    event.preventDefault(); // prevent default behavior (optional)
  }

  async emitDayChange(day: string, employee: any, code: string) {
    let IsAllow = false;
    if (!this.CompanyPermiter.IsAttendanceForSameDayAllowed && this.common.ToLowerCase(employee[day]) == 'p') {
      IsAllow = await this.ESS_ValidateSaveAttendanceOAS(day, employee[day], employee);
    } else {
      IsAllow = true;
    }

    if (!IsAllow) {
      employee[day] = 'A';
    }

    this.daychange.emit({
      DailyAttendanceInOutID: employee['DailyAttendanceInOutId_' + day.replace(/\s+/g, '')],
      EmpMasterId: employee.EmpMasterId,
      DesignationMasterId: employee.DesignationMasterId,
      DutyMasterId: employee.DutyMasterId,
      ShiftMasterId: 0,
      AttendanceRemark: employee[day],
      AttendanceDate: day,
      OTHours: null,
      RelievingHours: null,
      IsUpdate: false,
    });
  }

  convertDateFormate(Date: string, WithTime = false) {
    if (!WithTime) {
      return this.datePipe.transform(Date, 'dd MMM yyyy')
    } else {
      return this.datePipe.transform(Date, 'dd MMM yyyy, HH:mm:ss')
    }
  }

  clearBuffer() {
    this.keyBuffer = '';
    if (this.bufferTimeout) {
      clearTimeout(this.bufferTimeout);
      this.bufferTimeout = null;
    }
  }

  handleDesignationDutyChange(type: any, newValue: any, i: number, employee: any) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Shift will change after change designatoin and duty?';
    modalRef.result.then(result => {
      if (result) {
        if (type == 'Designation') {
          this.ComboLoad('Duty', i, employee.CDesignationMasterId, 0, true);
        } else if (type == 'Duty') {
          this.ComboLoad('ShiftLoadBasedOnDesignationDuty', i, employee.CDesignationMasterId, employee.CDutyMasterId, true);
        }
      } else {
        if (type == 'Designation') {
          employee.CDesignationMasterId = employee.PDesignationMasterId;
        } else if (type == 'Duty') {
          employee.CDutyMasterId = employee.PDutyMasterId;
        }

      }
    });
  }

  storePrevious(type: any, Data: any) {
    if (type == 'Designation') {
      Data.PDesignationMasterId = Data.CDesignationMasterId;
    } else if (type == 'Duty') {
      Data.PDutyMasterId = Data.CDutyMasterId;
    }
  }

  isAttendanceAllowed(day: string, employee: any): any {
    let classname = '';
    const index = this.ErrorHighlight.findIndex((e: any) => e.EmpMasterId == employee.EmpMasterId && e.DesignationMasterID == employee.DesignationMasterId && e.DutyMasterID == employee.DutyMasterId && e.AttendanceDate == day);
    if (index >= 0) {
      classname = 'errorHighlight';
    } else {
      const difDay = this.getDayDifference(this.CompanyPermiter.TodayDate, day);
      if (((difDay == 0
        || (difDay < 0 && this.CompanyPermiter.IsAttendanceBeforeDaysAllowed && this.CompanyPermiter.AttendanceBeforeDays >= Math.abs(difDay)
          || (difDay > 0 && this.CompanyPermiter.IsAttendanceAfterDaysAllowed && this.CompanyPermiter.AttendanceAfterDays >= difDay)))
        && !this.IsLocked && this.common.PageRight.IsEdit)
      ) {
        if (!employee['IsAttendanceAllowed_' + day.replace(/\s+/g, '')] || !this.CheckJoinLeftDate(day, employee.JoiningDate, employee.LeftDate)) {
          classname = 'notallow';
        } else if (employee[day] == 'P') {
          classname = 'present';
        } else if (employee[day] == 'A') {
          classname = 'absent';
        } else if (employee[day] == 'L') {
          classname = 'leave';
        }
      } else {
        classname = 'notallow';
      }


      if (employee.Fouce == day) {
        classname += ' selected-cell';
      }
    }


    return classname;
  }

  onDayFocus(Type: string, day: string, employee: any) {
    if (Type == 'F') {
      employee.Fouce = day;
    } else {
      employee.Fouce = '';
    }
  }

  CheckJoinLeftDate(Day: any, JoiningDate: any, LeftDate: any) {
    return new Date(Day).getTime() >= new Date(JoiningDate).getTime() && (LeftDate == null || new Date(Day).getTime() <= new Date(LeftDate).getTime());
  }

  getDayDifference(d1: string, d2: string): number {
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    // Reset hours to 0 to avoid time-related issues
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diff = (date2.getTime() - date1.getTime()) / msPerDay;

    return diff; // positive = date2 after date1, negative = date2 before date1
  }

  deleteEmp(index: number) {
    if (!this.IsLocked && this.common.PageRight.IsDelete) {
      this.deleteEmpClick.emit(index);
    }
  }

  async ESS_ValidateSaveAttendanceOAS(AttendanceDate: string, AttendanceRemark: string, employee: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_ValidateSaveAttendanceOAS({
        'SelectType': 'AllowAttendanceForSameDay', SiteId: this.siteID,
        AttendanceDate: AttendanceDate, AttendanceRemark: AttendanceRemark,
        EmpMasterId: employee.EmpMasterId, DailyAttendanceInOutId: employee['DailyAttendanceInOutId_' + AttendanceDate.replace(/\s+/g, '')]
      }).subscribe({
        next: (response) => {
          if (response.Table[0].Column1 == '01') {
            resolve(true);
          } else {
            resolve(false);
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Table2[0].Column1;
            modalRef.componentInstance.Message2 = "Employee <b>" + employee.EmpCode + "-" + employee.FullName + "</b> is already presnet at site <b>" + response.Table[0].SiteCode + "-" + response.Table[0].SiteName + "<b/>. Date: " + AttendanceDate;
            modalRef.result.then((result: any) => { });
          }
        },
        complete: () => { },
        error: (error) => {
          resolve(error);
        },
      });
    });
  }

  getDayAbbreviation(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  }

  TooltipPopup(index: number) {
    const modalRef = this.modalService.open(LeftJoingDatePopupComponent);
    modalRef.componentInstance.JoiningDate = this.tableData[index].JoiningDate;
    modalRef.componentInstance.LeftDate = this.tableData[index].LeftDate;
    modalRef.result.then(result => {
      if (result) {
      }
    });
  }

  isAttendanceErrorHighlight(employee: any) {
    let classname = '';
    const index = this.ErrorHighlight.findIndex((e: any) => e.EmpMasterId == employee.EmpMasterId && e.DesignationMasterID == employee.DesignationMasterId && e.DutyMasterID == employee.DutyMasterId);
    if (index >= 0) {
      classname = 'errorHighlight';
    }
    else {
      if (!this.CheckDesignationDuty(employee.DesignationMasterId, employee.DutyMasterId)) {
        classname = 'errorHighlight2';
      }
    }
    return classname;
  }

  CheckDesignationDuty(DesignationMasterId: number, DutyMasterId: number): boolean {
    if (DesignationMasterId > 0 && DutyMasterId > 0 && this.DesignationSummaryData != null && this.DesignationSummaryData.length > 0) {
      if (this.DesignationSummaryData.findIndex((e: any) => e.DesignationMasterId == DesignationMasterId && e.DutyMasterId == DutyMasterId) >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}

